import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Overlay: {
    position: 'fixed',
    display: 'block',
    width: '100%',
    height: '100%',
    top: '0px',
    left: '0',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: '99999',
  },
  Loader: {
    position: 'absolute',
    top: '20%',
    left: '50%',
    width: '100px',
    height: '100px',
  },
});
